import {
  PaymentMethod,
  type CompanyGig,
  type CompanyGigApplications,
} from "model/Gig";
import type {
  UpdateGigPayload,
  UpdateGigShiftPayload,
} from "services/api/company/gig.service";
import type {
  EditPaymentType,
  EditSkillItem,
} from "./teamPublicDetailsModal.contract";

interface BuildUpdateGigPayloadParams {
  readonly gigData: CompanyGig;
  readonly editPaymentType: EditPaymentType;
  readonly editRole: string;
  readonly editDescription: string;
  readonly parsedMinRate: number;
  readonly parsedMaxRate: number;
  readonly parsedAmountOfWorkers: number;
  readonly editSkills: ReadonlyArray<EditSkillItem>;
}

export function getApplicationWorkerExternalId(
  application: Pick<CompanyGigApplications, "worker">,
): string {
  return application.worker.externalId?.trim() ?? "";
}

/**
 * Maps gig shifts to API payload format.
 */
function mapShifts(gigData: CompanyGig): UpdateGigShiftPayload[] {
  return gigData.shifts.map((shift) => ({
    id: shift.id,
    startTime: shift.startTime,
    endTime: shift.endTime,
    breakStartTime: shift.breakStartTime ?? null,
    breakEndTime: shift.breakEndTime ?? null,
    deductionAmount: shift.deductionAmount ?? 0,
  }));
}

/**
 * Builds payload for updating a team public gig from edit state.
 */
export function buildUpdateGigPayload(
  params: BuildUpdateGigPayloadParams,
): UpdateGigPayload {
  return {
    paymentType: params.editPaymentType || PaymentMethod.NONE,
    role: params.editRole.trim(),
    description: params.editDescription.trim(),
    minRate: params.parsedMinRate,
    maxRate: params.parsedMaxRate,
    amountOfWorkers: params.parsedAmountOfWorkers,
    workGroupId: params.gigData.workGroupId,
    shifts: mapShifts(params.gigData),
    skills: params.editSkills.map((skillItem) => ({
      id: skillItem.type === "persisted" ? skillItem.id : undefined,
      skill: skillItem.skill,
      experience: 0,
    })),
  };
}
